<template>
  <div :class="['music-list', type === 0 ? 'all' : 'selected', isClose && 'is-close']">
    <p class="title">{{ type === 0 ? '全部音效' : '已选列表' }}</p>
    <div class="scroll">
      <div v-for="(item, index) in currentList" :key="index">
        <div :class="['music', lastSelectId === item.id && 'remove']" v-if="isShowMusic(item.id)">
          <i-icon v-if="type === 1" type="md-close" style="margin-right: 10px;cursor: pointer;" @click="removeSelect(item.id, index)" color="#ffffff"/>
          <p class="name">{{ item.musicName }}</p>
          <div class="button">
            <i-switch v-model="item.isOpen" v-if="type === 1" @on-change="switchIsOpen($event, item)">
              <span slot="open">O</span>
              <span slot="close">X</span>
            </i-switch>
            <div v-else @click="select(item)" class="add">+</div>
          </div>
        </div>
      </div>
    </div>
    <div :class="['close']" @click="switchList">
      <i-icon v-if="(type === 0 && !isClose) || (type === 1 && isClose)" type="ios-arrow-back" color="#ffffff"/>
      <i-icon v-else type="ios-arrow-forward" color="#ffffff"/>
    </div>
  </div>
</template>

<script>
import { playAudio, pauseAudio } from '../../../utils/audio'
import { mapState, mapMutations } from 'vuex'

export default {
  data () {
    return {
      isClose: false,
      lastSelectId: 0
    }
  },
  props: {
    type: {
      type: Number,
      default: 0
    }
  },
  computed: {
    ...mapState({
      isPlay: state => state.isPlay,
      allMusicList: state => state.allMusicList,
      selectedList: state => state.selectedList,
      selectedIdList: state => state.selectedIdList
    }),
    currentList () {
      return this.type === 0
        ? this.allMusicList
        : this.selectedList
    }
  },
  watch: {
    isClose (val) {
      this.$emit('setStatus', { type: this.type, bool: val })
    }
  },
  methods: {
    ...mapMutations(['updateSelectedList']),
    isShowMusic (id) {
      const isSelected = this.selectedIdList.includes(id)
      if (this.type === 0) {
        return !isSelected
      } else if (this.type === 1) {
        return true
      }
    },
    switchList () {
      this.isClose = !this.isClose
    },
    select (music) {
      this.lastSelectId = music.id
      setTimeout(() => {
        this.lastSelectId = 0
        this.updateSelectedList({ music })
      }, 300)
    },
    removeSelect (id, index) {
      this.lastSelectId = id
      setTimeout(() => {
        this.lastSelectId = 0
        this.updateSelectedList({ type: 'remove', music: { index } })
      }, 300)
    },
    switchIsOpen (status, elem) {
      if (!this.isPlay) { return false }
      status ? playAudio(elem) : pauseAudio(elem)
    }
  }
}
</script>

<style lang="scss" scoped>
@keyframes closeAni {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.music-list {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 320px;
  height: 100%;
  background: #242a30;
  padding: 0 30px;
  z-index: 1;
  transition: transform 0.35s ease-out;
  &.all {
    .music.remove {
      transition: transform 0.3s ease-in;
      transform: translateX(100%);
    }
    &.is-close {
      transform: translateX(-100%);
      .close {
        transform: translate(94%, -50%);
        border-radius: 0 10px 10px 0;
        background: rgba(0, 0, 0, 0.6);
        animation: closeAni 2s infinite;
        border: transparent;
        &:hover {
          background: rgba(0, 0, 0, 0.8);
          animation: none;
        }
      }
    }
    .close {
      border-radius: 10px 0 0 10px;
      border-left: 1px solid #cecfcf;
    }
  }
  &.selected {
    .music.remove {
      transition: transform 0.3s ease-in;
      transform: translateX(-100%);
    }
    &.is-close {
      transform: translateX(100%);
      .close {
        transform: translate(-94%, -50%);
        border-radius: 10px 0 0 10px;
        background: rgba(0, 0, 0, 0.6);
        animation: closeAni 2s infinite;
        border: transparent;
        &:hover {
          background: rgba(0, 0, 0, 0.8);
          animation: none;
        }
      }
    }
    .close {
      right: auto;
      left: 0;
      border-radius: 0 10px 10px 0;
      border-right: 1px solid #cecfcf;
    }
  }
  .close {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 50%;
    right: 0;
    width: 20px;
    height: 60px;
    transform: translateY(-50%);
    cursor: pointer;
    transition: background 0.2s ease-in;
    border-top: 1px solid #cecfcf;
    border-bottom: 1px solid #cecfcf;
    &:hover {
      background: #cecfcf;
    }
  }
  .title {
    color: #aab5b7;
    font-size: 18px;
    margin: 20px 0 0;
  }
  .scroll {
    flex: 1;
    overflow-x: hidden;
    overflow-y: scroll;
  }
  .music {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 48px;
    color: #6C7383;
    font-size: 16px;
    margin: 9px 0;
    .name {
      flex: 1;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      margin-right: 10px;
    }
    .button {
      .add {
        font-size: 30px;
        color: #aab5b7;
        cursor: pointer;
      }
    }
  }
}
</style>
